import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue';
import MfaOtpForm from './MfaOtpForm.vue';
import MfaService from '@/services/mfa.service';
import PageService from '@/core/page.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MfaEnterCode',
  props: {
    headline: null,
    title: null,
    token: null,
    description: null,
    codeInputText: null,
    submitButtonText: null,
    setupMode: { type: Boolean }
  },
  emits: ['submit'],
  setup(__props: any) {

const props = __props as {
    headline: string;
    title: string;
    token: string;
    description: string;
    codeInputText: string;
    submitButtonText: string;
    setupMode: boolean;
}





const showSpinner = ref(false);
const errorMessage = ref<string>('');
const qrCode = ref<string>('');

async function setup() {
    errorMessage.value = '';
    showSpinner.value = true;

    const response = await MfaService.setup(props.token).finally(() => showSpinner.value = false);

    if (response.qrCode) {
        qrCode.value = response.qrCode;
    } else if (response.redirectUrl) {
        PageService.hardRedirect(response.redirectUrl);
    } else {
        errorMessage.value = response.errorMessage;
    }
};

onBeforeMount(async() => {
    if (props.setupMode) {
        setup();
    }
});

async function finalizeSetup(form: IMfaOtpForm) {
    errorMessage.value = '';
    showSpinner.value = true;

    const response = await MfaService.finalizeSetup(form, props.token).finally(() => showSpinner.value = false);

    if (response.isLoggedIn) {
        PageService.hardRedirect(response.redirectUrl);
    } else {
        errorMessage.value = response.errorMessage;
    }
};

async function verify(form: IMfaOtpForm) {
    errorMessage.value = '';
    showSpinner.value = true;

    const response = await MfaService.verify(form, props.token).finally(() => showSpinner.value = false);

    if (response.isLoggedIn) {
        PageService.hardRedirect(response.redirectUrl);
    } else {
        errorMessage.value = response.errorMessage;
    }
};

return { __sfc: true,props, showSpinner, errorMessage, qrCode, setup, finalizeSetup, verify, MfaOtpForm }
}

})